import { api } from 'roboflex-thalamus-request-handler'

export default {
    async obterRedirectUrl(redirectTo = null) {
        const response = await api.get('google/calendar/redirect-url', {
            params: redirectTo ? { redirect_to: redirectTo } : undefined,
        })
        return response.data
    },

    async criarReuniaoGestaoEntregas(payload) {
        try {
            const response = await api.post('google/calendar/reunioes/gestao-entregas', payload)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error)
            throw error
        }
    },

    async excluirReuniaoGestaoEntregas(reuniaoGoogleId) {
        try {
            const response = await api.delete(`google/calendar/reunioes/gestao-entregas/${reuniaoGoogleId}`)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error)
            throw error
        }
    },

    async resolverReuniaoPorUrl(url) {
        try {
            const response = await api.post('google/calendar/reunioes/resolver-url', { url })
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error)
            throw error
        }
    },

    async anexarPdfReuniao(reuniaoGoogleId, file, categoria = 'gestao-entregas') {
        const formData = new FormData()
        formData.append('arquivo', file)
        formData.append('categoria', categoria)

        try {
            const response = await api.post(`anexar/reuniao/${reuniaoGoogleId}`, formData)
            return response.data
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') console.error(error)
            throw error
        }
    },
}
